import React from 'react';

/**
 * Iconos del modo de cobro, compartidos por TBBC/AXD/Optimize.
 * - IconDividido: gráfico de torta (el valor se reparte entre los marcados).
 * - IconUnitario: una sola barra (el valor completo se carga a cada cliente).
 */
export const IconDividido = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
    <path d="M22 12A10 10 0 0 0 12 2v10z" />
  </svg>
);

export const IconUnitario = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="9" y="4" width="6" height="16" rx="2" />
  </svg>
);
